// src/composables/useOfflineHandler.js
import { inject } from 'vue'

/**
 * Composable for handling offline functionality in components using the <script setup> syntax
 * @returns {Object} The offline handler utilities
 */
export function useOfflineHandler() {
  const offlineHandler = inject('offlineHandler')
  
  if (!offlineHandler) {
    console.warn('offlineHandler plugin not found. Make sure it\'s registered in main.js')
    
    // Return a minimal implementation to avoid errors
    return {
      getImageSrc: (src) => src,
      handleImageError: () => {},
      notifyOffline: () => {},
      notifyOnline: () => {},
      getFallbackContent: () => ({ message: 'Content not available offline' })
    }
  }
  
  return offlineHandler
}
